// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"306":"8cbe14f8","548":"844a685a"}[chunkId] + ".chunk.css";
};